import { render } from "./ChangelogEntry.vue?vue&type=template&id=29ff8104&scoped=true"
import script from "./ChangelogEntry.vue?vue&type=script&lang=js"
export * from "./ChangelogEntry.vue?vue&type=script&lang=js"

import "./ChangelogEntry.vue?vue&type=style&index=0&id=29ff8104&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\diafischchen-webpage\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ff8104"]])

export default __exports__